export default __webpack_public_path__ + "static/media/first-prize.aa638057.svg";